<template>
    <div class="chooselocation">
        <el-dialog title="门店地址" :close-on-click-modal="false" :close-on-press-escape="false" :visible="locationDialog" @close="$emit('close')" class="dele_dialog">
            <div class="linkage">
                <el-select v-model="provinceValue" @change="chooseProvince" placeholder="省级地区">
                    <el-option v-for="item in province" :key="item.id" :label="item.value" :value="item.id"></el-option>
                </el-select>
                <el-select v-model="cityValue" @change="chooseCity" placeholder="市级地区">
                    <el-option v-for="item in cityList" :key="item.id" :label="item.value" :value="item.id"></el-option>
                </el-select>
                <!-- <el-select v-model="districtValue" @change="chooseBlock" placeholder="区级地区">
                    <el-option v-for="item in districtList" :key="item.id" :label="item.value" :value="item.id"></el-option>
                </el-select> -->
                <el-input v-model="detailPosition" id="inputDetail" placeholder="请选择省市，然后输入详细地址" @blur="inputBlur()" clearable />
            </div>
            <MapView :positionValue="position" :lat="lat" :lng="lng" @initprovincecity="initprovincecity" @getMap="inputEvent" @currentPos="getCurrentPosition" @clickPoint="getClickPosition" ref="MapView" />
            <div class="current_position">
                <span>地图当前位置：</span>
                <span>{{currentPosition}}</span>
            </div>
            <div class="position_tips">请设置或拖动导航坐标到正确的位置，避免客户无法找到该门店地点</div>
            <div class="operate_btns">
                <el-button @click="$emit('close')">取消</el-button>
                <el-button type="primary" style="margin-left: 20px;" @click="confirm(position + ' ' + currentPosition)">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import jsonData from '@/assets/json/map.json'
import MapView from 'views/communityPurchase/managementOfPurchaseAndPurchase/components/mapView'
export default {
    name: 'chooseLocation',
    props: ['locationDialog', 'lat', 'lng', 'provincename', 'cityname', 'currentArea'],
    data() {
        return {
            province: '',
            provinceValue: this.provincename ? this.provincename : '北京市',
            cityValue: this.cityname ? this.cityname : '北京市',
            cityList: [],
            districtValue: '',
            districtList: [],
            city: '',
            block: '',
            position: this.currentArea,
            detailPosition: '',
            currentPosition: this.currentArea,
            point: null,
            isClickDD:false//是否点击下拉位置
        }
    },
    mounted() {
        this.getCityData()
        console.log(this.currentArea)
        if (this.currentArea) {
            this.changeInput(this.currentArea)
        }
        // this.inputEvent() // 关键字提示输入
    },
    methods: {
        initprovincecity(province, city) {
            this.provinceValue = province
            this.cityValue = city
        },
        inputEvent() {
            console.log(this.detailPosition)
            let ac = new BMap.Autocomplete({'input' : 'inputDetail', 'location': window.map})
            let myValue
            let that = this
            console.log(ac)
            ac.addEventListener('onconfirm', function(e) {
                console.log(e)
                let _value = e.item.value
                myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business
                // that.position = ''
                that.isClickDD = true
                that.$refs.MapView.getPrams(myValue)
                // that.initprovincecity(_value.province, _value.city)
                // console.log(that.provinceValue, that.cityValue)
                that.changeInput(myValue)
            })
            console.log(this.detailPosition)
        },

        changeInput(value) {
            this.detailPosition = value
        },

        getCurrentPosition(data,point) {
            this.currentPosition = data
            this.point = point
            console.log('point',point)
        },

        getClickPosition(data,point) {
            console.log('point',point, data)
            let res = data.split(',')
            this.provinceValue = res[0]
            this.cityValue = res[1]
            // this.districtValue = res[2]
            this.currentPosition = res[2]
            this.point = point
        },

        confirm(data) {
            this.$emit('thePosition', {province: this.provinceValue, city: this.cityValue, detailPosition: this.currentPosition, point: this.point})
        },

        inputBlur() {
                this.$refs.MapView.getPrams(this.position + this.detailPosition)

            if(!this.isClickDD){
                this.position = this.provinceValue + this.cityValue
            }
            else{
                this.isClickDD = false
            }
        },

        // 加载china地点数据，三级
        getCityData: function() {
            let that = this
            let data = jsonData
            that.province = []
            that.city = []
            that.block = []
            // 省市区数据分类
            for (let item in data) {
                if (item.match(/0000$/)) {
                    //省
                    that.province.push({
                        id: item,
                        value: data[item],
                        children: []
                    })
                } else if (item.match(/00$/)) {
                    //市
                    that.city.push({
                        id: item,
                        value: data[item],
                        children: []
                    })
                } else {
                    //区
                    that.block.push({
                        id: item,
                        value: data[item]
                    })
                }
            }
            // 分类市级
            for (let index in that.province) {
                for (let index1 in that.city) {
                    if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
                        that.province[index].children.push(that.city[index1])
                    }
                }
            }
            // 分类区级
            for (let item1 in that.city) {
                for (let item2 in that.block) {
                    if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
                        that.city[item1].children.push(that.block[item2])
                    }
                }
            }
        },

        // 选省
        chooseProvince: function(e) {
            for (let index2 in this.province) {
                if (e === this.province[index2].id) {
                    this.cityList = this.province[index2].children
                    this.cityValue = this.province[index2].children[0].value
                    this.districtList = this.province[index2].children[0].children
                    // this.districtValue = this.province[index2].children[0].children[0].value
                    this.E = this.districtList[0].id
                    this.provinceValue = this.province[index2].value

                    this.position = this.provinceValue + ' ' + this.cityValue
                    this.$refs.MapView.getPrams(this.position)
                }
            }
        },

        // 选市
        chooseCity: function(e) {
            for (let index3 in this.city) {
                if (e === this.city[index3].id) {
                    this.districtList = this.city[index3].children
                    this.districtValue = this.city[index3].children[0].value
                    this.E = this.districtList[0].id

                    this.cityValue = this.city[index3].value
                    this.position = this.provinceValue + ' ' + this.cityValue

                    this.$refs.MapView.getPrams(this.position)
                }
            }
        },

        // 选区
        chooseBlock: function(e) {
            console.log(e)
            this.E = e
            console.log(this.E)
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        MapView
    }
}
</script>

<style type="scss" lang="scss" type="text/scss">
.tangram-suggestion {
    z-index: 99999;
}
.chooselocation {
    #allmap {
        width: 1040px;
        height: 410px;
    }
    .el-dialog {
        width: 1080px;
        height: 690px;
    }
    .linkage {
        display: flex;
        justify-content: space-between;
        .el-select {
            width: 170px;
            height: 35px;
            input {
                width: 170px;
            }
        }
        >.el-input {
            width: 640px;
            height: 35px;
            input {
                width: 100%;
            }
        }
    }
    .current_position {
        font-size: 14px;
        span {
            color: #36383A;
        }
        span:first-child {
            color: #409EFF;
        }
    }
    .position_tips {
        font-size: 14px;
        color: #F56C6C;
        margin-top: 10px;
    }
    .operate_btns {
        width: 212px;
        margin: 30px auto;
    }
}
</style>